import axios from 'axios';
import type { ExtraParams } from './typings/imageFilter';

const api = axios.create({
    baseURL: process.env.VUE_APP_CUSTOMILY_IMAGE_FILTER_API_URL,
    responseType: 'blob'
});

export const generateWordCloudImage = (file: File, params: ExtraParams) => {
    const payload = new FormData();
    payload.append('imagefile', file);
    payload.append('extra_params', JSON.stringify(params));
    return api
        .post<Blob>('', payload, { params: { filters: 'word_art' } })
        .then((res) => res.data);
};
